import { ConditionalTooltip } from "@/pages/discountManagement/components/ConditionalTooltip";
import { Booking } from "@/types";
import { truncateText } from "@/utils/truncateText";
import { useMediaQuery } from "@mui/material";

const BookingPointCard = ({ booking }: { booking: Booking }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  const formatPoints = (points: number) => {
    return `${points} ${points < 2 ? "Point" : "Points"}`;
  };

  return (
    <div className="mb-3 rounded-lg border border-[#E2E8F0] bg-white px-3 py-5 shadow-sm">
      <div className="mb-2 flex justify-between text-sm font-medium text-[#334155]">
        <span>Wallet Address</span>
        <span className="flex items-end text-sm font-semibold text-text">
          <ConditionalTooltip
            text={booking.walletAddress}
            maxLength={15}
            isMobile={isMobile}
          >
            <span className=" line-clamp-1 flex w-[172px] items-center justify-end font-medium  text-text">
              {truncateText(booking.walletAddress, 15)}
            </span>
          </ConditionalTooltip>
        </span>
      </div>
      <div className="mb-2 flex justify-between text-sm font-medium text-[#334155]">
        <span>Points Earned</span>
        <span className="text-base font-semibold text-[#1E293B]">
          {formatPoints(booking.totalBookingPoints)}
        </span>
      </div>
      <div className="mb-2 flex justify-between text-sm font-medium text-[#334155]">
        <span>Referral Points Earned</span>
        <span className="text-base font-semibold text-[#1E293B]">
          {formatPoints(booking.totalReferralPoints)}
        </span>
      </div>
      <div className="mb-2 flex justify-between text-sm font-medium text-[#334155]">
        <span>Points Used</span>
        <span className="text-base font-semibold text-[#1E293B]">
          {formatPoints(booking.totalClaimedPoints)}
        </span>
      </div>
      <div className="flex justify-between text-sm font-medium text-[#334155]">
        <span>Points Available</span>
        <span className="text-base font-semibold text-[#1E293B]">
          {formatPoints(booking.totalAvailablePoints)}
        </span>
      </div>
    </div>
  );
};

export default BookingPointCard;
